import { Button } from '@almbrand/button';
import { BasketThemeName } from '../Basket.types';
import styles from './BasketBottomActions.module.scss';

interface BasketBottomActionsProps {
	themeName: BasketThemeName;
	onBack: () => void;
	onCheckout: () => void;
	text?: {
		backBtnLabel?: string;
		checkoutBtnLabel?: string;
	};
}

export type BasketBottomActionsText = NonNullable<BasketBottomActionsProps['text']>;

export const BasketBottomActions: React.FC<BasketBottomActionsProps> = ({
	themeName,
	onBack,
	onCheckout,
	text: { backBtnLabel = 'Tilbage', checkoutBtnLabel = 'Checkout' } = {},
}) => {
	return (
		<div className={styles.BasketBottomActions}>
			<Button
				buttonType='circle'
				iconProps={{
					themeName,
					icon: 'arrow_left_tail_long',
					fill: 'var(--primary-dark-text)',
					'aria-label': backBtnLabel,
				}}
				className={styles.BasketBottomActions__backButton}
				onClick={onBack}
			>
				{backBtnLabel}
			</Button>

			<Button
				buttonType='primary'
				className={styles.BasketBottomActions__checkoutButton}
				onClick={onCheckout}
			>
				{checkoutBtnLabel}
			</Button>
		</div>
	);
};
